import script from "./SerpQueryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SerpQueryView.vue?vue&type=script&setup=true&lang=js"

import "./SerpQueryView.vue?vue&type=style&index=0&id=b54e92ba&lang=scss"

const __exports__ = script;

export default __exports__